import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter as Router } from '@react-router';
import { loadableReady } from '@loadable/component';
import { useSSR } from 'react-i18next';
import { ErrorBoundary } from './ErrorBoundary';
import globalWindow from '@shared/core/globals';
import App from './App';
import '@shared/core/i18n/i18n';
import { FullPageLoaderProvider } from '@shared/components/JoyLogoLoader/FullPageLoaderProvider';

const BaseApp: React.FC = props => {
  useSSR(globalWindow.__INITIAL_I18N_STORE__, globalWindow.__INITIAL_I18N_LANG__);
  return (
    <ErrorBoundary>
      <FullPageLoaderProvider>
        <Router>
          <App
            {...props}
            initialEventHandleForEventInfoProvider={globalWindow.__INITIAL_EVENT_HANDLE_FOR_EVENT_INFO_PROVIDER__}
            defaultScreen={globalWindow.__INITIAL_DEVICE_SCREEN__}
          />
        </Router>
      </FullPageLoaderProvider>
    </ErrorBoundary>
  );
};

// Wait for all scripts to load asynchronously
loadableReady(() => {
  const root = document.getElementById('root');

  hydrate(<BaseApp />, root);
});

if (process.env.NODE_ENV === 'development') {
  module.hot?.accept();
}
